module.exports = __webpack_public_path__ + "img/row-srp-preview-honda.5b09c459.png";